export const regions = [
  { label: "Parral", value: "Parral" },
  { label: "Delicias", value: "Delicias" },
  { label: "Cuauhtémoc", value: "Cuauhtémoc" },
  { label: "Chihuahua", value: "Chihuahua" },
  { label: "Zona centro sur", value: "Zona centro sur" }
]

export const regionsFilter = [
  { label: "Parral", value: "PARRAL" },
  { label: "Delicias", value: "DELICIAS" },
  { label: "Cuauhtémoc", value: "CUAUHTEMOC" },
  { label: "Chihuahua", value: "CHIHUAHUA" },
  { label: "Zona centro sur", value: "ZONA CENTRO SUR" }
]

export const CONCEPT_REGIONS = [
  { label: "Parral", value: "Parral" },
  { label: "Delicias", value: "Delicias" },
  { label: "Cuauhtémoc", value: "Cuauhtémoc" },
  { label: "Chihuahua", value: "Chihuahua" }
]

export const townships = [
  {
    region: "Parral",
    townships: [
      "Allende",
      "Balleza",
      "Batopilas",
      "Coronado",
      "El Tule",
      "Guachochi",
      "Guadalupe y Calvo",
      "Hidalgo del Parral",
      "Huejotitan",
      "Jiménez",
      "Lopez",
      "Matamoros",
      "Morales",
      "Rosario",
      "San Francisco del Oro",
      "Santa Bárbara",
      "Valle de Zaragoza"
    ]
  },
  {
    region: "Delicias",
    townships: [
      "Camargo",
      "Delicias",
      "Julimes",
      "La Cruz",
      "Meoqui",
      "Rosales",
      "Saucillo",
      "San Francisco de Conchos"
    ]
  },
  {
    region: "Cuauhtémoc",
    townships: [
      "Bachiniva",
      "Bocoyna",
      "Carichi",
      "Chínipas",
      "Cuauhtémoc",
      "Cusihuirachi",
      "Gómez Farías",
      "Guazaparez",
      "Guerrero",
      "Madera",
      "Maguarichi",
      "Matachic",
      "Moris",
      "Namiquipa",
      "Nonoava",
      "Ocampo",
      "San Francisco de Borja",
      "Temosachic",
      "Urique",
      "Uruachi"
    ]
  },
  {
    region: "Chihuahua",
    townships: [
      "Aldama",
      "Aquiles Serdán",
      "Chihuahua",
      "Coyame del Sotol",
      "Dr. Belisario Domínguez",
      "Gran Morelos",
      "Manuel Benavides",
      "Ojinaga",
      "Riva Palacio",
      "Santa Isabel",
      "Satevó"
    ]
  },
  {
    region: "Otro",
    townships: [
      "Estatal",
      "Zona centro sur"
    ]
  }
]
